import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SingleScrollableContainerComponent } from "../layouts/single-scrollable-container/single-scrollable-container.component";
import { ErrorType } from './error.model';

@Component({
    selector: 'app-error',
    imports: [SingleScrollableContainerComponent, RouterLink, FontAwesomeModule],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
})
export class ErrorComponent {
    errorTypes = ErrorType;
    errorType = input.required<ErrorType>();
}
